export const OrganizationAccessOptions = Object.freeze({
    ORGANISATION_USER: 'user',
    ORGANISATION_ADMIN: 'admin',
});
